import {
  GreenGreen70,
  Image,
  Inspector,
  Box,
  Flex
} from '@sequencehq/core-components'
import { stripeIntegrationConfig } from '../stripe.integration.config'
import { FC, ReactNode } from 'react'
import { useIntegrationActive } from 'Integrations/utils/useIntegrationActive'
import { SmallIcon } from 'Integrations/integrationsConfig/common/SmallIcon'
import addStripeIcon from './addStripeIcon.svg'
import addStripeIconInactive from './addStripeIconInactive.svg'
import { NotConnectedItemContent } from 'Integrations/integrationsConfig/common/NotConnectedItemContent'

const StripeNotConnected = () => (
  <Inspector.IconItem
    data-testid="stripe.inspector.item"
    tooltip="Stripe"
    icon={<Image src={addStripeIconInactive} height="30px" width="30px" />}
    activeIcon={<Image src={addStripeIcon} height="30px" width="30px" />}
    content={
      <NotConnectedItemContent
        serviceName={stripeIntegrationConfig.title}
        serviceDescription={stripeIntegrationConfig.description}
        logo={
          <Image
            src={stripeIntegrationConfig.smallLogoUrl}
            height="24px"
            width="24px"
          />
        }
        service="Stripe"
        data-testid="stripe.inspector.content.notConnected"
      />
    }
  />
)

export const StripeInspectorItem: FC<{
  alwaysShow?: boolean
  enabled?: boolean
  children: ReactNode
}> = props => {
  const integrationActive = useIntegrationActive('Stripe')

  if (!integrationActive) {
    return <StripeNotConnected />
  }

  return (
    <Inspector.IconItem
      id="stripe.inspector.item"
      data-testid="stripe.inspector.item"
      tooltip="Stripe"
      icon={<StripeIconWithBadge enabled={props.enabled} />}
      content={
        <Inspector.Content
          data-testid="stripe.inspector.content"
          title="Stripe"
          icon={<StripeIcon />}
        >
          <Flex flexDirection="column" gap="16px">
            {props.children}
          </Flex>
        </Inspector.Content>
      }
    />
  )
}

export const StripeIcon: FC<{ onClick?: () => void }> = ({ onClick }) => (
  <SmallIcon url={stripeIntegrationConfig.smallLogoUrl} onClick={onClick} />
)

const StripeIconWithBadge: FC<{ enabled?: boolean }> = ({ enabled }) => (
  <Box position="relative">
    <StripeIcon />
    {enabled && (
      <Box
        data-testid="stripe.inspector.item.badge"
        position="absolute"
        top="-4px"
        right="-4px"
        height="8px"
        width="8px"
        borderRadius="full"
        backgroundColor={GreenGreen70}
        boxShadow="0 0 0 1.5px white"
      />
    )}
  </Box>
)
